import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import React from 'react';
import { Controller } from 'react-hook-form';
import CustomDateInputField from './CustomDateInputField';
import CustomTimeInputField from './CustomTimeInputField';

const StartingDate = ({ fromDate, toDate, control, labels, utils }) => (
  <Box sx={{ p: 1 }}>
    <FormControl variant="standard" fullWidth>
      <InputLabel shrink htmlFor="starting-date">
        {labels.startingDate || 'Starting Date'}
      </InputLabel>
      <Controller
        render={({ field }) => (
          <CustomDateInputField
            {...field}
            maxDate={toDate}
            size="small"
            id="starting-date"
            format="YYYY-MM-DD"
            value={fromDate}
            onChange={momentFrom => {
              if (momentFrom && utils.isValid(momentFrom)) {
                field.onChange(momentFrom);
              }
            }}
          />
        )}
        name={'fromDate'}
        control={control}
      />
    </FormControl>
    <Box sx={{ mt: 1 }}>
      <Controller
        render={({ field }) => (
          <DateCalendar
            {...field}
            maxDate={toDate}
            value={fromDate}
            onChange={momentFrom => {
              if (momentFrom && utils.isValid(momentFrom)) {
                field.onChange(momentFrom);
              }
            }}
            sx={{ backgroundColor: 'surface.2', borderRadius: '5px', width: '277px', height: '325px' }}
          />
        )}
        name={'fromDate'}
        control={control}
      />
    </Box>
    <FormControl variant="standard" fullWidth sx={{ mt: 1 }}>
      <InputLabel shrink htmlFor="starting-time">
        {labels.startingTime || 'Starting Time'}
      </InputLabel>
      <Controller
        render={({ field }) => (
          <CustomTimeInputField
            {...field}
            value={fromDate}
            maxTime={toDate}
            ampm={false}
            size="small"
            id="starting-time"
            onChange={momentFrom => {
              if (momentFrom && utils.isValid(momentFrom)) {
                field.onChange(momentFrom);
              }
            }}
          />
        )}
        name={'fromDate'}
        control={control}
      />
    </FormControl>
  </Box>
);

export default StartingDate;
